<template>
  <el-dialog
    title="Выгрузка в банк"
    width="900px"
    class="payment-bank-modal"
    :visible="visible && isLoadDays"
    :before-close="() => $emit('close')"
  >
    <content-modal :content="content" :visible-modal="visible" />
  </el-dialog>
</template>

<script>
import ContentModal from './Content/Content'

export default {
  name: 'PaymentsModal',
  components: { ContentModal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isLoadDays() {
      let res = true

      if (!this.content.load_days_ids.length) {
        this.$message.warning('Не выбран ни один день')
        res = false
      }

      return res
    },
  },
}
</script>
